
import React from 'react';

export default class ExtendProps extends React.Component<any, any> {
    
    public render() { 
        const arialabel = this.props.arialabel; 
        const childArray= [this.props.children];

        return (
            // this.props.children as JSX.Element
            ((childArray!==undefined) && (childArray.length===1)?
                React.cloneElement(
                React.Children.only(this.props.children), 
                { ['aria-label']: arialabel })
            : this.props.children)
            
        );
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/focuslock/extendprops.tsx